/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import Class from "model/character/Class";

// Hardcoded class rules data / lookup tables extracted from ClassService.
// These are data, not logic: preserve exact return values and fallback behavior.

export function getSpellCastingAttributeByClassName(fullClassName: string): string {
    switch (fullClassName.toLowerCase()) {
        case 'bard':
        case 'paladin':
        case 'sorcerer':
        case 'warlock':
            return 'Charisma';

        case 'druid':
        case 'cleric':
        case 'ranger':
        case 'rogue/soulspy':
        case 'rogue/underfoot':
            return 'Wisdom';

        case 'fighter/arcane warrior':
        case 'rogue/eldritch trickster':
        case 'rogue/smuggler':
        case 'wizard':
            return 'Intelligence';
    }
    return '';
}

export function getMultiClassRequirementAttribute(className: string): string {
    let attrName = '';
    if (className === 'Barbarian')     attrName = 'Strength';
    else if (className === 'Bard')     attrName = 'Charisma';
    else if (className === 'Cleric')   attrName = 'Wisdom';
    else if (className === 'Druid')    attrName = 'Wisdom';
    else if (className === 'Fighter')  attrName = 'Strength or Dexterity';
    else if (className === 'Monk')     attrName = 'Dexterity and Wisdom';
    else if (className === 'Paladin')  attrName = 'Strength and Charisma';
    else if (className === 'Ranger')   attrName = 'Dexterity and Wisdom';
    else if (className === 'Rogue')    attrName = 'Dexterity';
    else if (className === 'Sorcerer') attrName = 'Charisma';
    else if (className === 'Warlock')  attrName = 'Charisma';
    else if (className === 'Wizard')   attrName = 'Intelligence';
    return attrName;
}

export function getSecondClassArmorProficiencies(classInfo: Class): string {
    switch (classInfo?.name) {
        case 'Barbarian': return 'Shields';
        case 'Bard':      return 'Light Armor';
        case 'Cleric':    return 'Light Armor, Medium Armor, Shields';
        case 'Druid':     return 'Light Armor, Medium Armor, Shields (druids will not wear armor or use shields made of metal)';
        case 'Fighter':   return 'Light Armor, Medium Armor, Shields';
        case 'Monk':      return '';
        case 'Paladin':   return 'Light Armor, Medium Armor, Shields';
        case 'Ranger':    return 'Light Armor, Medium Armor, Shields';
        case 'Rogue':     return 'Light Armor';
        case 'Sorcerer':  return '';
        case 'Warlock':   return 'Light Armor';
        case 'Wizard':    return '';
    }
    return '';
}

export function getSecondClassWeaponProficiencies(classInfo: Class): string {
    switch (classInfo?.name) {
        case 'Barbarian': return 'Simple Weapons, Martial Weapons';
        case 'Bard':      return '';
        case 'Cleric':    return '';
        case 'Druid':     return '';
        case 'Fighter':   return 'Simple Weapons, Martial Weapons';
        case 'Monk':      return 'Simple weapons, Shortsword';
        case 'Paladin':   return 'Simple Weapons, Martial Weapons';
        case 'Ranger':    return 'Simple Weapons, Martial Weapons';
        case 'Rogue':     return '';
        case 'Sorcerer':  return '';
        case 'Warlock':   return 'Simple Weapons';
        case 'Wizard':    return '';
    }
    return '';
}

export function getSecondClassSkillProficiencies(classInfo: Class): string {
    switch (classInfo?.name) {
        case 'Barbarian': return '';
        case 'Bard':      return 'One skill of your choice, one Musical Instrument of your choice';
        case 'Cleric':    return '';
        case 'Druid':     return '';
        case 'Fighter':   return '';
        case 'Monk':      return '';
        case 'Paladin':   return '';
        case 'Ranger':    return 'Choose one from Animal Handling, Athletics, Insight, Investigation, Nature, Perception, Stealth, and Survival';
        case 'Rogue':     return 'Thieves\' Tools, plus choose one from Acrobatics, Athletics, Deception, Insight, Intimidation, Investigation, Perception, Performance, Persuasion, Sleight of Hand, and Stealth';
        case 'Sorcerer':  return '';
        case 'Warlock':   return '';
        case 'Wizard':    return '';
    }
    return '';
}
